export const formatMoney = (amount: number): string => {
  if (isNaN(amount)) {
    return null;
  }
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
  }).format(Number(amount)); // £7,574.00
};
